export const getPendingPaymentUrl = (
	potsUrl: string,
	requestPubUuid: string,
	language: string
): string => {
	const url = new URL(`collect/pending/${encodeURIComponent(language)}`, potsUrl)
	url.searchParams.set('uuid', requestPubUuid)
	return url.toString()
}

/**
 * Extracts request_pub_uuid from a payment URL
 * Supports patterns like: /collect/payment/{uuid}, /payment/{uuid}, /cb/{uuid}, /p/{uuid}
 */
export const extractRequestPubUuidFromUrl = (url: string): string | null => {
	try {
		const urlObj = new URL(url)
		const pathSegments = urlObj.pathname.split('/').filter(Boolean)
		// Look for payment-related segments
		const paymentIndex = pathSegments.findIndex(
			(segment) => segment === 'payment' || segment === 'cb' || segment === 'p'
		)
		if (paymentIndex !== -1 && paymentIndex + 1 < pathSegments.length) {
			return pathSegments[paymentIndex + 1]
		}
		// Also check for /collect/payment/{uuid} pattern
		const collectIndex = pathSegments.findIndex((segment) => segment === 'collect')
		if (collectIndex !== -1 && collectIndex + 1 < pathSegments.length) {
			const nextSegment = pathSegments[collectIndex + 1]
			if (nextSegment === 'payment' && collectIndex + 2 < pathSegments.length) {
				return pathSegments[collectIndex + 2]
			}
		}
		return null
	} catch {
		return null
	}
}
